/**
 * @generated SignedSource<<7907770a3256cc6b804941d76dc217ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetQuotePermissionInput = {
  clientMutationId?: string | null;
  quoteId: string;
  role: string;
  userId: string;
};
export type QuoteUserManagementComponentSetUserPermissionMutation$variables = {
  input: SetQuotePermissionInput;
};
export type QuoteUserManagementComponentSetUserPermissionMutation$data = {
  readonly setQuotePermission: {
    readonly quote: {
      readonly companyName: string | null;
      readonly id: string;
      readonly projectName: string | null;
      readonly userRoles: ReadonlyArray<{
        readonly email: string | null;
        readonly isActive: boolean | null;
        readonly role: string | null;
        readonly user: {
          readonly firstName: string;
          readonly id: string;
          readonly lastName: string;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type QuoteUserManagementComponentSetUserPermissionMutation = {
  response: QuoteUserManagementComponentSetUserPermissionMutation$data;
  variables: QuoteUserManagementComponentSetUserPermissionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetQuotePermissionPayload",
    "kind": "LinkedField",
    "name": "setQuotePermission",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QuoteNode",
        "kind": "LinkedField",
        "name": "quote",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SourceUserRoleNode",
            "kind": "LinkedField",
            "name": "userRoles",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isActive",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuoteUserManagementComponentSetUserPermissionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuoteUserManagementComponentSetUserPermissionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2bdddb50e3dc5239a17bd51f8cc64ce6",
    "id": null,
    "metadata": {},
    "name": "QuoteUserManagementComponentSetUserPermissionMutation",
    "operationKind": "mutation",
    "text": "mutation QuoteUserManagementComponentSetUserPermissionMutation(\n  $input: SetQuotePermissionInput!\n) {\n  setQuotePermission(input: $input) {\n    quote {\n      id\n      projectName\n      companyName\n      userRoles {\n        user {\n          id\n          firstName\n          lastName\n        }\n        email\n        role\n        isActive\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "09f65b464f6c7576ad727baf18c5bfc9";

export default node;
